import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_URL } from '../constants';
import { BaseDataService, DataService } from '../core/services';

@Injectable()
export class ContractsService extends BaseDataService {

    constructor(protected dataService: DataService) {
        super(dataService, API_URL);
    }

    public getContract(id?: number): Observable<any> {
        let url = `Contract/GetContract?id=${id}`;
        return super.getAll<any>(url);
    }

    public getContracts(data) {
        let url = `Contract/GetContracts`;
        return super.save<any>(url, data);
    }

    public DownloadContractList(siteId) {
        let url = `Contract/DownloadConractList?siteId=${siteId}`;

        return super.savePDF<any>(url, 'application/pdf');
    }

    public saveContracts(data) {
        let url = `Contract/AddContract`;
        return super.save<any>(url, data);
    }

    public getContractCategories(data) {
        let url = `Contract/GetContractCategories`;
        return super.save<any>(url, data);
    }

    public getTagWords(accountId?: number): Observable<any> {
        let url = `Contract/GetTagWords?accountId=${accountId}`;
        return super.getAll<any>(url);
    }

    public copyContracts(data: any): Observable<any> {
        let url = `Contract/Copy`;
        return super.save<any>(url, data);
    }

    public updateContractsYear(data: any): Observable<any> {
        let url = `Contract/BulkUpdate`;
        return super.save<any>(url, data);
    }

    public GetContractRoles(accountId?: number): Observable<any> {
        let url = `Contract/GetContractRoles?accountId=${accountId}`;
        return super.getAll<any>(url);
    }

    public saveContractCategory(data) {
        let url = `Contract/AddContractCategory`;
        return super.save<any>(url, data);
    }

    public deleteContractCategory(data) {
        let url = `Contract/DeleteContractCategory`;
        return super.save<any>(url, data);
    }
    public GetXls(siteId: number, accountId: number, userId: number, searchValue: string) {

        let url = `Contract/GetExcelBySiteId?siteId=${siteId}&accountId=${accountId}&userId=${userId}&searchValue=${searchValue}`;

        return super.savePDF<any>(url, 'application/pdf');
    }

    public getContractCategory(id?: number): Observable<any> {
        let url = `Contract/GetCategory?id=${id}`;
        return super.getAll<any>(url);
    }

    public deleteContracts(data) {
        let url = `Contract/Delete`;
        return super.save<any>(url, data);
    }

    //legal holders
    public saveLegalHOlder(data) {
        let url = `Contract/AddLegalHolder`;
        return super.save<any>(url, data);
    }

    public SendFiles(data) {
        let url = `Contract/SendFiles`;
        return super.save<any>(url, data);
    }

    public saveTagWord(data) {
        let url = `Contract/AddTagWord`;
        return super.save<any>(url, data);
    }

    public saveContractRole(data) {
        let url = `Contract/AddContractRole`;
        return super.save<any>(url, data);
    }

    public DeleteLegalHolder(data) {
        let url = `Contract/DeleteLegalHolder`;
        return super.save<any>(url, data);
    }

    public GetLegalHolder(id?: number): Observable<any> {
        let url = `Contract/GetLegalHolder?id=${id}`;
        return super.getAll<any>(url);
    }

    public getLegalHolders(data) {
        let url = `Contract/GetLegalHolders`;
        return super.save<any>(url, data);
    }
    //opponent

    public saveOpponent(data) {
        let url = `Contract/AddOpponent`;
        return super.save<any>(url, data);
    }

    public DeleteOpponent(data) {
        let url = `Contract/DeleteOpponent`;
        return super.save<any>(url, data);
    }

    public DeleteTagWord(data) {
        let url = `Contract/DeleteTagWord`;
        return super.save<any>(url, data);
    }

    public DeleteContractRole(data) {
        let url = `Contract/DeleteContractRole`;
        return super.save<any>(url, data);
    }

    public GetTagWordForCreate(accountId?: number): Observable<any> {
        let url = `Contract/GetContractTagWordsForCreate?accountId=${accountId}`;
        return super.getAll<any>(url);
    }

    public GetTagWord(id?: number): Observable<any> {
        let url = `Contract/GetTagWordById?id=${id}`;
        return super.getAll<any>(url);
    }

    public GetContractRole(id?: number): Observable<any> {
        let url = `Contract/GetContractRoleById?id=${id}`;
        return super.getAll<any>(url);
    }

    public GetOpponent(id?: number): Observable<any> {
        let url = `Contract/GetOpponent?id=${id}`;
        return super.getAll<any>(url);
    }

    public GetOpponents(data) {
        let url = `Contract/GetOpponents`;
        return super.save<any>(url, data);
    }

    public getFiles(id?: number): Observable<any> {
        let url = `Contract/GetFiles?id=${id}`;
        return super.getAll<any>(url);
    }

    public DownloadReport(id: number) {
        let url = `Contract/DownloadReport?id=${id}`;

        return super.savePDF<any>(url, 'application/pdf');
    }

    public SaveEmailCC(data: any): Observable<any> {
        let url = `Account/Contract/CC`
        return super.save<any>(url, data);
    }

    public GetEmailCC(accountId: number): Observable<any> {
        let url = `Account/Contract/CC?accountId=${accountId}`
        return super.getAll<any>(url);
    }

    public GetRemindEmailSetting(accountId: number, siteId: number): Observable<any> {
        let url = `Contract/Reminder?accountId=${accountId}&siteId=${siteId}`
        return super.getAll<any>(url);
    }

    public SaveRemindEmailSetting(data): Observable<any> {
        let url = `Contract/Reminder`
        return super.save<any>(url, data);
    }


}



// WEBPACK FOOTER //
// ./src/app/services/contracts.service.ts